import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db6c58a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pools-tile" }
const _hoisted_2 = { class: "legend" }
const _hoisted_3 = { style: {"font-weight":"bold"} }
const _hoisted_4 = { class: "items" }
const _hoisted_5 = { class: "legend-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot",
  style: {"background":"#72BF44"}
}, null, -1 /* HOISTED */))
const _hoisted_7 = { class: "legend-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot",
  style: {"background":"#E4E4E4"}
}, null, -1 /* HOISTED */))
const _hoisted_9 = { class: "legend-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot",
  style: {"background":"#27697F"}
}, null, -1 /* HOISTED */))
const _hoisted_11 = { class: "legend-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot",
  style: {"background":"#FFF1A9"}
}, null, -1 /* HOISTED */))
const _hoisted_13 = {
  style: {"height":"100%","width":"100%","max-width":"350px","margin-left":"auto","margin-right":"auto"},
  ref: "poolsRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.$t("DASHBOARD_VIEW.POOLS")), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("DASHBOARD_VIEW.COMMUNITY_POOL")), 1 /* TEXT */),
          _createVNode($setup["Icon"], { name: "ArrowRight" }),
          _createVNode($setup["CoinAmount"], {
            amount: $setup.tokensStore.getCommunityPool,
            "show-denom": true,
            style: {"font-weight":"bold"}
          }, null, 8 /* PROPS */, ["amount"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("DASHBOARD_VIEW.REMAINING_TOKENS")), 1 /* TEXT */),
          _createVNode($setup["Icon"], { name: "ArrowRight" }),
          _createVNode($setup["CoinAmount"], {
            amount: $setup.tokensStore.getRemainingTokens,
            "show-denom": true,
            style: {"font-weight":"bold"}
          }, null, 8 /* PROPS */, ["amount"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("DASHBOARD_VIEW.STRATEGIC_REVERSE_POOL")), 1 /* TEXT */),
          _createVNode($setup["Icon"], { name: "ArrowRight" }),
          _createVNode($setup["CoinAmount"], {
            amount: $setup.tokensStore.getStrategicReversePool,
            "show-denom": true,
            style: {"font-weight":"bold"}
          }, null, 8 /* PROPS */, ["amount"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("DASHBOARD_VIEW.AIRDROP")), 1 /* TEXT */),
          _createVNode($setup["Icon"], { name: "ArrowRight" }),
          _createVNode($setup["CoinAmount"], {
            amount: $setup.tokensStore.getAirdropPool,
            "show-denom": true,
            style: {"font-weight":"bold"}
          }, null, 8 /* PROPS */, ["amount"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode($setup["ShadowedSvgChart"], { id: "poolschartdiv" }, {
        default: _withCtx(() => [
          _createVNode($setup["VChart"], {
            option: $setup.option,
            autoresize: ""
          }, null, 8 /* PROPS */, ["option"]),
          _createVNode($setup["C4EIcon"], {
            icon: "c4e-circle",
            class: "inside",
            size: $setup.poolsRef.clientWidth/3
          }, null, 8 /* PROPS */, ["size"])
        ]),
        _: 1 /* STABLE */
      })
    ], 512 /* NEED_PATCH */)
  ]))
}